import Shared from "@/common/shared";

export default class PageParameters {
  public page!: number;
  public pageSize!: number;

  constructor() {
    this.page = 1;
    this.pageSize = Shared.defaultPageSize;
  }
}
